import { Avatar, AvatarImage, toast } from 'alm-react-components'
import { useContext } from 'react'
import { duration } from '../../../lib/utils'
import { AppContext } from '../../../context/AppProvider'
import defaultUserImg from "./../../../assets/images/user-mtbg.svg";
import { DeleteCommentModal } from '../discussion-board/comment-section/DeleteCommentModal';
import { apis } from '../../../services/alm';
import { useTranslation } from 'react-i18next';
import { delteNotesReplies } from '../../../services/notes';
import useAlmCorporateStatus from '../../../hooks/useAlmCorporateStatus';

type Props = {
    notesReplies: any
    setIsAlmReplies: any
    isAlmCommentId?:any
}

const RepliesList = (props: Props) => {

    const { state } = useContext(AppContext);
    const { t } = useTranslation()
    useAlmCorporateStatus();
    const payloadForReply = {
        almCommentId: props.isAlmCommentId,
      };
    const onDelete = (commentId: string) => {
        apis.deleteReply(commentId).then((res: any) => {
            if (res.error) {
                toast({
                    description: res.error.title, variant: "error",
                })
            } else {
                toast({
                    description: t('DiscussionBoard.commentDeleted'), variant: "success",
                });
                const remComment = props.notesReplies?.filter((comment: any) => {
                    return comment.id !== commentId;
                });
                if(!remComment.length){
                    delteNotesReplies(payloadForReply)
                }
                props.setIsAlmReplies(remComment)
            }
        }).catch((error: any) => console.log(error));
    }
    return (
        <>
            {
                props?.notesReplies?.map((res: any) => {
                    return <>
                        <div className="grid w-full">
                            <div className="flex my-8 space-x-6 lg:space-x-6 relative">
                                <div className="flex-none relative">
                                    <span className="relative flex h-[50px] w-[50px] shrink-0 overflow-hidden rounded-full">
                                        <Avatar className="border h-[50px] w-[50px]">
                                            {state?.user && state?.user?.avatarUrl != "" ? (
                                                <AvatarImage src={state?.user?.avatarUrl} />
                                            ) : (
                                                <AvatarImage src={defaultUserImg} />
                                            )}
                                        </Avatar>
                                    </span>
                                </div>
                                <div className="flex flex-col w-full">
                                    <div className="flex flex-col">
                                        <div className="flex flex-row  ">
                                            <div className="w-2/3 text-base font-opensansBold leading-none pb-2">
                                                {state?.user?.fields?.displayName ? state?.user?.fields?.displayName : state?.user?.name}
                                            </div>
                                            <div className="w-2/3 flex justify-end">
                                                <DeleteCommentModal onDelete={onDelete} id={res?.id} />
                                            </div>
                                        </div>
                                        <div>
                                            <p className="text-base text-normal">{res?.attributes?.text}</p>
                                        </div>
                                    </div>
                                    <div className="flex flex-row justify-end">

                                        <div className="flex flex-row items-center text-base font-light dark:text-muted-foreground px-3">
                                            {duration(res?.attributes?.dateCreated)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                })
            }
        </>
    )
}

export default RepliesList